import classnames from 'classnames';
import React from 'react';

type StepState = 'idle' | 'active' | 'completed';

interface Step {
	label: string;
	state?: StepState;
}

interface HorizontalStepperProps {
	steps: Step[];
	activeStepIndex?: number;
	className?: string;
	dataqa?: string;
}

function StepDot({ state }: { state: StepState }) {
	const cls = classnames('horizontal-stepper-dot', state);
	return (
		<div className={cls}>
			{state === 'completed' && (
				<i className="pi pi-check horizontal-stepper-check" />
			)}
		</div>
	);
}

function HorizontalStepper({
	steps,
	activeStepIndex,
	className,
	dataqa,
}: HorizontalStepperProps) {
	const resolvedSteps = steps.map((step, idx) => ({
		...step,
		state: step.state ?? resolveState(idx, activeStepIndex),
	}));

	const cls = classnames('common-ui-horizontal-stepper', className);

	return (
		<div className={cls} data-qa={dataqa}>
			{resolvedSteps.map((step, index) => {
				const isLast = index === resolvedSteps.length - 1;
				const nodeCls = classnames('horizontal-stepper-node', step.state);

				return (
					<React.Fragment key={`${index}-${step.label}`}>
						<div className={nodeCls}>
							<StepDot state={step.state} />
							<span className="horizontal-stepper-label">{step.label}</span>
						</div>
						{!isLast && <div className="horizontal-stepper-line" />}
					</React.Fragment>
				);
			})}
		</div>
	);
}

function resolveState(
	index: number,
	activeStepIndex: number | undefined
): StepState {
	if (activeStepIndex === undefined) return 'idle';
	if (index < activeStepIndex) return 'completed';
	if (index === activeStepIndex) return 'active';
	return 'idle';
}

export default HorizontalStepper;
